import { CalendarSettingsContext } from '../../../../contexts/customer/calendar-settings.context';
import { UserContext } from '../../../../contexts/user.context';
import { CalendarReservationContainer, BlackoutTitleSpanContainer } from './calendar-reservation.styles'
import { ResDetailDivContainer, ResTitleSpanContainer, ResTitleAndEmojiContainer } from './calendar-reservation.styles';
import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { createOpenSlot } from '../../../../utils/reservation-utils/reservation-utils';
import { SearchForReservationContext } from '../../../../contexts/search-for-reservation/search-for-reservation.context';
import dayjs from 'dayjs';

function wc_hex_is_light(color) {
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substring(0, 0 + 2), 16);
    const c_g = parseInt(hex.substring(2, 2 + 2), 16);
    const c_b = parseInt(hex.substring(4, 4 + 2), 16);
    const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
    return brightness > 155;
}

const sportToEmoji = (reservation) => {
    const upperCase = reservation.reservedForSport ? reservation.reservedForSport.toUpperCase() : "";
    let emoji = null;
    if (upperCase.includes("BASKETBALL")) {
        emoji = "🏀";
    }

    if (upperCase.includes("BASEBALL")) {
        emoji = "⚾️";
    }

    if (upperCase.includes("LACROSSE")) {
        emoji = "🥍";
    }

    if (upperCase.includes("SOCCER")) {
        emoji = "⚽️";
    }

    if (upperCase.includes("SOFTBALL")) {
        emoji = "🥎";
    }

    if (upperCase.includes("TRAINING")) {
        emoji = "⏱️";
    }

    if (upperCase.includes("VOLLEYBALL")) {
        emoji = "🏐";
    }

    if (emoji) {
        return `${emoji}`;
    } else {
        return null;
    }

}

const CalendarReservation = ({ facilityArea, reservation, hoursOfOperation }) => {

    const { calendarSettings } = useContext(CalendarSettingsContext);
    const { clickToBookOpenSlot, setClickToBookOpenSlot } = useContext(SearchForReservationContext);
    const textRef = useRef(null); // Reference to the text element
    const [isOverflowing, setIsOverflowing] = useState(false);
    const { title, mainAreaReservedType, subTitle } = reservation;
    const { subAreas } = facilityArea;
    const { userData } = useContext(UserContext);

    useEffect(() => {
        if (textRef.current) {
            const { scrollHeight } = textRef.current; // Dimensions of the text
            const { offsetHeight } = textRef.current.parentElement; // Dimensions of the container
            setIsOverflowing(
                scrollHeight > offsetHeight
            ); // Check if text fits both width and height
        }
    }, [title]);

    if (!hoursOfOperation) {
        return null;
    }

    const handleClick = (e) => {
        e.preventDefault();
    }

    const handleBlackoutClicked = (e) => {
        e.preventDefault();
       
        if (userData) {
            console.log('CLINT ', reservation, "F A ", facilityArea);
            if (reservation.reservedForCustomers && reservation.reservedForCustomers.includes(userData.userId))
                if (calendarSettings.allowWebCalendarBookings) {
                    const openSlotToBook = createOpenSlot(1, dayjs(`${reservation.dateKey} ${reservation.resStartTime}`, 'YYYY-MM-DD h:mm A' ), dayjs(`${reservation.dateKey} ${reservation.resEndTime}`, 'YYYY-MM-DD h:mm A' ), reservation.facilityArea ? reservation.facilityArea : facilityArea, dayjs(`${reservation.dateKey} ${reservation.resEndTime}`, 'YYYY-MM-DD h:mm A' ));
                    openSlotToBook.anchorEl = e.target;
                    setClickToBookOpenSlot(openSlotToBook);
                }
        }
    }

    let numberOfColumns = 1;
    let spanColumns = '1 / 1';
    if (subAreas) {

        subAreas.sort((area1, area2) => {
            if (area1.sortOrder < area2.sortOrder) {
                return -1;
            }

            if (area1.sortOrder > area2.sortOrder) {
                return 1;
            }

            return 0;
        });

        if (mainAreaReservedType !== 'sub') {
            let columnStart = -1;
            let areasFound = 0;
            let subCount = 1;
            for (const subArea of subAreas) {
                for (const reservationAreaId of reservation.areaIds) {
                    if (subArea.id === reservationAreaId) {
                        areasFound += 1;
                        if (columnStart === -1) {
                            columnStart = subCount;
                        }
                    }
                }
                subCount += 1;
            }
            spanColumns = `${columnStart} / ${areasFound + 1}`;
            numberOfColumns = areasFound;
        } else {
            let subAreaCount = 1;
            let columnNumber = 1;
            for (const subArea of subAreas) {
                if (reservation.areaIds.includes(subArea.id)) {
                    columnNumber = subAreaCount;
                }
                subAreaCount += 1;
            }
            if (columnNumber > 0) {
                spanColumns = `${columnNumber} / ${columnNumber + 1}`;
            } else {
                spanColumns = `1 / 1`;
            }

        }
    }

    let titleColumnSpan = spanColumns;
    if (mainAreaReservedType === 'sub') {
        titleColumnSpan = '1';
    }

    const rowStartTimesToRowStart = {};
    if (hoursOfOperation) {

        let startTime = hoursOfOperation.startDateTime.clone();
        let endTime = hoursOfOperation.endDateTime.clone();

        let rowStart = 0;
        while (startTime.isBefore(endTime)) {
            rowStartTimesToRowStart[startTime.format('h A')] = rowStart
            startTime.add(60, 'minutes');
            rowStart += 4;
        }
    }

    const resStartMinutes = parseInt(reservation.startDate.format("m"));
    let rowsAdd = 1;
    if (resStartMinutes === 15) {
        rowsAdd += 1
    } else if (resStartMinutes === 30) {
        rowsAdd += 2
    } else if (resStartMinutes === 45) {
        rowsAdd += 3
    }

    const startResInRow = (rowStartTimesToRowStart[reservation.startDate.format('h A')]) + rowsAdd;
    const resLengthInMinutes = reservation.endDate.diff(reservation.startDate, 'minutes');
    const fifteenMinutesIntervals = resLengthInMinutes / 15;
    const endResInRow = startResInRow + fifteenMinutesIntervals;

    let resTitleBackgroudColor = `${calendarSettings.secondaryFacilityColor}`;
    let resTitleColor = `${calendarSettings.mainFacilityColor}`;
    let borderStyle = 'hidden';
    let borderColor = `${calendarSettings.mainFacilityColor}`;
    let cursor = 'not-allowed';

    if (!wc_hex_is_light(resTitleColor)) {
        resTitleColor = 'white';
    }

    if (!userData && reservation.isBlackOutPeriod) {
        resTitleColor = 'white';
        resTitleBackgroudColor = '#00000075';
    }

    if (userData && reservation.isBlackOutPeriod && ( !reservation.reservedForCustomers || !reservation.reservedForCustomers.includes(userData.userId))) {
        resTitleColor = 'white';
        resTitleBackgroudColor = '#00000075';
    }

    if (userData && reservation.isBlackOutPeriod && reservation.reservedForCustomers && reservation.reservedForCustomers.includes(userData.userId)) {
        resTitleColor = calendarSettings.mainFacilityColor;
        resTitleBackgroudColor = '#00000000';
        borderStyle = 'solid';
        cursor = 'pointer'
    }
    console.log(reservation)
    return (
        <CalendarReservationContainer $numberofcolumns={numberOfColumns} $gridrowstart={`${startResInRow}`} $gridrowend={`${endResInRow}`} $gridcolumn={spanColumns} $borderstyle={borderStyle} $bordercolor={borderColor} $cursor={cursor}>
            <ResDetailDivContainer $spancolumn={titleColumnSpan} $spanrow={'1'} $backgroundcolor={resTitleBackgroudColor} $overflow={!isOverflowing ? 'scroll' : 'hidden'} >
                {
                    !reservation.isBlackOutPeriod &&
                    <ResTitleAndEmojiContainer $backgroundcolor={resTitleBackgroudColor} ref={textRef}>
                        <ResTitleSpanContainer $fontSize={'1.5vh'} $titlecolor={resTitleColor} $backgroundcolor={resTitleBackgroudColor} onClick={handleClick.bind(this)} $wrap={!isOverflowing ? 'wrap' : 'nowrap'}>
                            {`${reservation.isInternalBooking ? calendarSettings.showInternalBookingTitlesOnWebCalendar ? isOverflowing ? "" : title : 'Internal' : calendarSettings.showReservationTitlesOnWebCalendar ? isOverflowing ? "" : title : 'Reserved'}`}
                        </ResTitleSpanContainer>
                    </ResTitleAndEmojiContainer>
                }
                {
                    reservation.isBlackOutPeriod &&
                    <Fragment>
                        <BlackoutTitleSpanContainer onClick={handleBlackoutClicked.bind(this)} $fontSize={'1.5vh'} $backgroundcolor={resTitleBackgroudColor} $titlecolor={resTitleColor} >
                            {`${calendarSettings.showBlackoutTitlesOnWebCalendar ? !subTitle ? `${title}` : `${title} - ${subTitle}` : 'Blacked Out'}`}
                        </BlackoutTitleSpanContainer>
                    </Fragment>
                }
            </ResDetailDivContainer>
        </CalendarReservationContainer>
    )

}

export default CalendarReservation;